/**
 * Get the textual content of a Rich Text value. This is similar to
 * `Element.textContent`.
 *
 * @param {Object} value Value to use.
 *
 * @return {string} The text content.
 */
export function getTextContent(_ref) {
  var text = _ref.text;
  return text;
}
//# sourceMappingURL=get-text-content.js.map